import { Service } from './http-service';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type {
  CreateMediaDto,
  Media as RosMedia,
  MediaControllerGetUploadUrlResponse,
  UpdateMediaDto,
  MediaControllerFindAllData,
} from '@carvia/ros-client-types';
import axios from 'axios';
import { httpClient } from './http-client';

class MediaService extends Service<RosMedia, CreateMediaDto, UpdateMediaDto> {
  constructor() {
    super('/media');
  }

  async getAllWithQuery(params: MediaControllerFindAllData['query']) {
    const res = await this.httpClient.get<PaginatedResponse<RosMedia>>(`${this.endpoint}`, {
      params,
    });
    return res.data;
  }

  async getUploadUrl(params: { originalFileName: string; mimeType: string }) {
    const res = await this.httpClient.get<MediaControllerGetUploadUrlResponse>(
      `${this.endpoint}/upload-url`,
      { params },
    );
    return res.data;
  }

  async uploadVideoFile(originalFileName: string, file: Blob) {
    const mimeType = file.type;
    const { url, fileKey } = await this.getUploadUrl({ originalFileName, mimeType });
    await axios.put(url, file, {
      headers: {
        'Content-Type': mimeType,
      },
    });
    return { fileKey };
  }
}

export const mediaService = new MediaService();
